class Interview {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // Swiperのインスタンスを保持する変数
    let swiperInstance;

    // Swiperを初期化する関数
    let swiperTouchStartX;

    const scrollbar = document.querySelector("#js-slider__scroll");
    const scrollbar_growbar = document.querySelector("#js-slider__scrollGrowbar");
  
    var scrollbar_w;
    var scrollbar_drag_w;
    var progress_range;

    swiperInstance = new Swiper('.interview-swiper', {
      slidesPerView: 1.1,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 500, // スライドの速度をミリ秒単位で指定
      loop: true, // ループモードを有効にする
      navigation: {
        nextEl: `.swiper-button--next`,
        prevEl: `.swiper-button--prev`,
      },
      grabCursor: true,
      scrollbar: {
        el: scrollbar,
        draggable: true,
      },
      breakpoints: {
        // スライドの表示枚数：768px以上の場合
        768: {
          slidesPerView: 3.6,
        }
      },
      on: {
        init(swiper) {
          // スライド総数
          const totalSlidesLen = swiper.slides.length;
        },
        /**
         * Swiper上でドラッグされ始めたときの処理
         */
        touchStart(swiper, e) {
          /**
           * タッチされたX座標を保存
           * タッチ時とクリック時でイベントの返り値が変わるため処理を分岐
           */
          if (e.type === 'touchstart') {
            swiperTouchStartX = e.touches[0].clientX;
          } else {
            swiperTouchStartX = e.clientX;
          }
        },
        /**
         * Swiper上でドラッグし終わったときの処理
         */
        touchEnd(swiper, e) {
          // スワイプ判定のしきい値
          const tolerance = 150;
          // スライド総数
          const totalSlidesLen = swiper.slides.length;
    
          // 左にスワイプしたか右にスワイプしたかを判定
          const diff = (() => {
            if (e.type === 'touchend') {
              return e.changedTouches[0].clientX - swiperTouchStartX;
            } else {
              return e.clientX - swiperTouchStartX;
            }
          })();
    
          /**
           * タッチ開始時と、タッチ終了時のカーソルの座標を比較し、下記のどちらかに分岐させる。
           */
          // 最初のスライド上で左にスワイプされたときは最後のスライドに飛ばす
          if (swiper.isBeginning && diff >= tolerance) {
            swiper.slideTo(totalSlidesLen - 1);
          // 最後のスライド上で右にスワイプさせたときは最初のスライドに飛ばす
          } else if (swiper.isEnd && diff <= -tolerance) {
            // 一瞬待ってから最初のスライドに飛ばす
            // （少し遅らせないと、最初のスライドに戻った後に右スワイプ判定が走って2番目のスライドに飛ばされてしまうため）
            setTimeout(() => {
              swiper.slideTo(0);
            }, 1);
          }
        },
        resize: () => {
          scrollbar_w = scrollbar.clientWidth;
          scrollbar_drag_w = scrollbar.querySelector(".swiper-scrollbar-drag").clientWidth;
          gsap.to(scrollbar_growbar, {
            width: (scrollbar_w - scrollbar_drag_w) * progress_range + scrollbar_drag_w,
          });
        },
        progress: (swiper, progress) => {
          progress_range = progress;
          gsap.to(scrollbar_growbar, {
            width: (scrollbar_w - scrollbar_drag_w) * progress_range + scrollbar_drag_w,
          });
        },
      },
    });
    
    scrollbar_w = scrollbar.clientWidth;
    scrollbar_drag_w = scrollbar.querySelector(".swiper-scrollbar-drag").clientWidth;
  }
}
